const SITE_TITLE = '[en]Cerebellar Platform[/en][ja]小脳プラットフォーム[/ja]';
const SITE_SLOGAN = 'Official Site';
// Replaces the Universal Analytics property (UA-2787349-1), shut down in 2023.
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-K94TTGLC6K';
const XOONIPS_ITEMTYPES = ['data', 'model', 'paper', 'book', 'tool', 'url', 'memo', 'binder'];
const D3FORUM_MODULES = ['forum'];
const PICO_MODULES = ['documents'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's Config.BASE_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

export type MultiLang = 'en' | 'ja';

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    XOONIPS_ITEMTYPES,
    D3FORUM_MODULES,
    PICO_MODULES,
    BASE_URL,
};

export default Config;
